import ApiClient from '@/api/api-client'

export default function() {
    return {
        getCustomer: function() {
            return ApiClient.get('/customer')
        },

        postSaveMarketingConsents: function(payload) {
            return ApiClient.post('/customer/save-marketing-consents', payload)
        }
    }
}
